// extracted by mini-css-extract-plugin
export default {"changeType":"change-type__anP7i7vF","text":"text__ghIWYycD"};